export interface CursorStep {
  move: () => Promise<void>;
  openCard: () => Promise<void>;
  holdCard: () => Promise<void>;
  closeCard: () => Promise<void>;
  cardGap: () => Promise<void>;
  rest: () => Promise<void>;
}

export type CardGate = (showCard: () => Promise<void>) => Promise<void>;

export function createCardGate(): CardGate {
  let queue = Promise.resolve();

  return async (showCard) => {
    const previous = queue;
    let release = () => {};
    queue = new Promise<void>((resolve) => {
      release = resolve;
    });

    await previous;

    try {
      await showCard();
    } finally {
      release();
    }
  };
}

export async function runCursorStep(step: CursorStep, cardGate: CardGate) {
  await step.move();

  await cardGate(async () => {
    await step.openCard();
    await step.holdCard();
    await step.closeCard();
    await step.cardGap();
  });

  await step.rest();
}
